import { createStore, applyMiddleware, compose } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import thunk from 'redux-thunk'
import storage from 'redux-persist/lib/storage'
import rootReducers from './reducers'

const initialState = {}
const middleware = [thunk]
const persistConfig = {
  key: 'root',
  storage
}

const composeEnhancers =
    typeof window === 'object' &&
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      : compose

const enhancer = composeEnhancers(applyMiddleware(...middleware))

const persistedReducer = persistReducer(persistConfig, rootReducers)
const store = createStore(persistedReducer, initialState, enhancer)
const persistor = persistStore(store)

export { store, persistor }
